import { render, staticRenderFns } from "./CPTemp8.vue?vue&type=template&id=20834415&scoped=true&"
import script from "./CPTemp8.vue?vue&type=script&lang=js&"
export * from "./CPTemp8.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp8.vue?vue&type=style&index=0&id=20834415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20834415",
  null
  
)

export default component.exports